module.exports = __webpack_public_path__ + "img/MAZATLAN.10b46f10.jpeg";